import React from 'react';
import Sidebar from '../Sidebar';

const AppSidebar = () => {
  return <Sidebar />;
};

export default React.memo(AppSidebar);
